import { Box, Typography } from '@mui/material';

const NoDataOverlay = () => {
  return (
    <Box
      sx={{
        height: '100%',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        p: 10,
      }}>
      <Typography variant="body2" color="text.secondary">
        <h3>No records found</h3>
      </Typography>
    </Box>
  );
};

export default NoDataOverlay;
